import React from "react";

import SwitchOnOff from "../common/tools/SwitchOnOff";

import type { JSX } from "react";

function SwitchWithLabel({
  label,
  name,
  isChecked,
  onChange,
  disabled,
}: {
  label: string;
  name: string;
  isChecked: boolean;
  disabled?: boolean;
  onChange: (isChecked: boolean) => void;
}): JSX.Element {
  return (
    <div className="flex justify-start gap-2.5 align-middle">
      <span className="my-auto font-normal">{label}</span>
      <SwitchOnOff
        checked={isChecked}
        disabled={disabled}
        name={name}
        onChange={(): void => onChange(!isChecked)}
        size="sm"
      />
    </div>
  );
}

export default SwitchWithLabel;
